// import axiosInstance from "../configuration/api";
// import { Series } from "../interface/series";

// const baseUrl = process.env.REACT_APP_API_HOST;

// export const createSeries = async (
//   seriesData: Omit<Series, "_id" | "models">
// ) => {
//   try {
//     const response = await axiosInstance.post(
//       `${baseUrl}/api/series`,
//       seriesData
//     );
//     return response.data;
//   } catch (error: any) {
//     throw new Error(error.response?.data?.message || "Failed to create series");
//   }
// };

// export const getAllSeries = async () => {
//   try {
//     const response = await axiosInstance.get(`${baseUrl}/api/series`);
//     return response.data;
//   } catch (error: any) {
//     throw new Error(error.response?.data?.message || "Failed to fetch series");
//   }
// };

// export const getSeriesById = async (id: string) => {
//   try {
//     const response = await axiosInstance.get(`${baseUrl}/api/series/${id}`);
//     return response.data;
//   } catch (error: any) {
//     throw new Error(error.response?.data?.message || "Series not found");
//   }
// };

// export const deleteSeries = async (id: string) => {
//   try {
//     const response = await axiosInstance.delete(`${baseUrl}/api/series/${id}`);
//     return response.data;
//   } catch (error: any) {
//     throw new Error(error.response?.data?.message || "Failed to delete series");
//   }
// };
import axiosInstance from "../configuration/api";
import { Series } from "../interface/series";

export const createSeries = async (
  seriesData: Omit<Series, "_id" | "models">
) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.post(
    `${baseUrl}/api/v1/series`,
    seriesData
  );
  return response.data;
};

export const getAllSeries = async () => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.get(`${baseUrl}/api/v1/series`);
  return response.data;
};

export const updateSeries = async (id: string, updateData: Partial<Series>) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.patch(
    `${baseUrl}/api/v1/series/${id}`,
    updateData
  );
  return response.data;
};

export const deleteSeries = async (id: string) => {
  const baseUrl = process.env.REACT_APP_API_HOST;
  const response = await axiosInstance.delete(`${baseUrl}/api/v1/series/${id}`);
  return response.data;
};
